import _assign from "lodash/assign";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * An error occured during input validation
 * @example
 * // Constructed error converted to JSON:
 * {
 *   "name": "ValidationError",
 *   "errors": {
 *     "thing.requiredInput": ["This input is required"]
 *   }
 * }
 * @property {String} name ValidationError
 * @property {Object} errors Keys represent dot notation of the input that failed validation
 */
var ValidationError = function ValidationError(message, errors) {
  _classCallCheck(this, ValidationError);

  _assign(this, {
    name: 'ValidationError',
    errors: errors,
    message: message,
    statusCode: 400,
    stack: new Error().stack
  });
};

export default ValidationError;